import { YouTubeEmbed } from '@next/third-parties/google';
import { getYouTubeId } from 'services/lib/util';

const YoutubeCustom = ({ item }) => {
  const videoId = getYouTubeId(item?.videoExternal);

  if (!videoId) {
    return null;
  }

  return (
    <div className="videoWrapper w-full px-0">
      <YouTubeEmbed videoid={videoId} params="modestbranding=1&rel=0" />
    </div>
  );
};

export default YoutubeCustom;
